module.exports = __webpack_public_path__ + "static/img/Omosefe.09ea33e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Omosefe.jpeg
// module id = MVxB
// module chunks = 0